/*eslint-disable*/
import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import algoliasearch from "algoliasearch/lite"
// eslint-disable-next-line import/no-unresolved
import { useLocation } from "@reach/router"
import ProductCardSearch from "../components/ProductCardSearch"
import { getValuesFromQuery } from "../utils/searchHelper"

const SearchPageTemplate = () => {
  const searchClient = algoliasearch(
    "9041ONZ5KO",
    "c717af898e008132cee8e5d596a3ef6a",
  )
  const indexName = "Pages"
  const [loading, setLoading] = useState(true)
  const [allProducts, setAllProducts] = useState([])
  const location = useLocation()

  useEffect(() => {
    const queryParams = getValuesFromQuery(location.search).term
    if (queryParams) {
      setLoading(true)
      const searchIndex = searchClient.initIndex(indexName)
      searchIndex
        .search(queryParams)
        .then(({ hits }) => {
          setLoading(false)
          setAllProducts(hits)
        })
        .catch(err => {
          setLoading(false)
          return err
        })
    }
  }, [location])

  let showProducts = []
  if (allProducts.length) {
    showProducts = allProducts.filter(product => product.status === "ACTIVE")
  }
  const topSellersQuery = useStaticQuery(graphql`
    query topSellersQuery {
      allShopifyProduct(filter: { tags: { in: "top-seller" } }) {
        edges {
          node {
            handle
            shopifyId
            title
            description
            status
            variants {
              compareAtPrice
              price
              shopifyId
            }
            descriptionHtml
            shopifyId
            tags
            priceRangeV2 {
              maxVariantPrice {
                amount
                currencyCode
              }
              minVariantPrice {
                amount
                currencyCode
              }
            }
            metafields {
              key
              value
              valueType
              description
              shopifyId
            }
            media {
              id
              preview {
                image {
                  height
                  altText
                  src
                  width
                  originalSrc
                }
              }
            }
          }
        }
      }
    }
  `)
  let showTopSellerProducts = []
  if (showTopSellerProducts) {
    showTopSellerProducts = topSellersQuery?.allShopifyProduct?.edges.filter(
      product => product.node.status === "ACTIVE",
    )
  }

  return (
    <div className="px-5 md:px-20 bg-[#f6f6f6] pb-10 md:pb-20">
      <h1 className="pt-4 mb-0 text-sm font-semibold">
        Home <span className="font-light text-sm">/ Search</span>
      </h1>
      <h1 className="text-xl font-bold">Search Results</h1>

      {loading ? "Loading..." : null}
      {showProducts?.length > 0 && !loading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
          {showProducts?.map(item => (
            <ProductCardSearch key={item.hander} product={item} />
          ))}
        </div>
      ) : null}
      {!loading && !allProducts?.length && showTopSellerProducts.length ? (
        <div>
          <p className="font-sans font-black text-xl mb-4">
            No Results, but here are our top sellers:
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
            {showTopSellerProducts.map(item => (
              <ProductCardSearch key={item.node.handle} product={item.node} />
            ))}
          </div>
        </div>
      ) : null}
      {!loading &&
      !allProducts?.length &&
      !topSellersQuery?.allShopifyProduct?.edges?.length
        ? "No Results"
        : null}
    </div>
  )
}

export default SearchPageTemplate
